module.exports = __webpack_public_path__ + "static/Zapier-f70b23b473719a534d7b44cded5c4562.jpg";